
/*PS4 PRO*/
import PS4_1 from '../images/Consoles/PS4 Pro/ps4-pro-card(1).webp';
import PS4_2 from '../images/Consoles/PS4 Pro/ps4-pro-card(2).webp';
import PS4_3 from '../images/Consoles/PS4 Pro/ps4-pro-card(3).webp';
import PS4_4 from '../images/Consoles/PS4 Pro/ps4-pro-card(4).webp';

/* Meta Quest 3 */
import MQ3_1 from '../images/Consoles/Meta Quest 3/quest3-card(1).webp';
import MQ3_2 from '../images/Consoles/Meta Quest 3/quest3-card(2).webp';
import MQ3_3 from '../images/Consoles/Meta Quest 3/quest3-card(3).webp';
import MQ3_4 from '../images/Consoles/Meta Quest 3/quest3-card(4).webp';

/* PS5BluRay */
import PS5BluRay_1 from '../images/Consoles/PS5 Blu-Ray/ps5-bluray-card(1).webp';
import PS5BluRay_2 from '../images/Consoles/PS5 Blu-Ray/ps5-bluray-card(2).webp';
import PS5BluRay_3 from '../images/Consoles/PS5 Blu-Ray/ps5-bluray-card(3).webp';
import PS5BluRay_4 from '../images/Consoles/PS5 Blu-Ray/ps5-bluray-card(4).webp';

/* PS5SlimBluRay */
import PS5SlimBluRay_1 from '../images/Consoles/PS5 Slim Blu-Ray/ps5-slim-bluray-card(1).webp';
import PS5SlimBluRay_2 from '../images/Consoles/PS5 Slim Blu-Ray/ps5-slim-bluray-card(2).webp';
import PS5SlimBluRay_3 from '../images/Consoles/PS5 Slim Blu-Ray/ps5-slim-bluray-card(3).webp';
import PS5SlimBluRay_4 from '../images/Consoles/PS5 Slim Blu-Ray/ps5-slim-bluray-card(4).webp';

/* XboxSeriesS */
import XboxSeriesS_1 from '../images/Consoles/Xbox Series S/series-S-card(1).webp';
import XboxSeriesS_2 from '../images/Consoles/Xbox Series S/series-S-card(2).webp';
import XboxSeriesS_3 from '../images/Consoles/Xbox Series S/series-S-card(3).webp';
import XboxSeriesS_4 from '../images/Consoles/Xbox Series S/series-S-card(4).webp';

/* XboxSeriesX */
import XboxSeriesX_1 from '../images/Consoles/Xbox Series X/series-X-card(1).webp';
import XboxSeriesX_2 from '../images/Consoles/Xbox Series X/series-X-card(2).webp';
import XboxSeriesX_3 from '../images/Consoles/Xbox Series X/series-X-card(3).webp';
import XboxSeriesX_4 from '../images/Consoles/Xbox Series X/series-X-card(4).webp';

const consoleDetails = [
    {
        id: 2,
        name: "PS5 Blu-Ray",
        image: [PS5BluRay_1, PS5BluRay_2, PS5BluRay_3, PS5BluRay_4],
        KIT: 'PS5_BLU_RAY_KIT' ,
        features: [
            { text: "Максимальна продуктивність – 4К, 120 FPS, HDR", boldWords: ["Максимальна продуктивність"] },
            { text: "Швидкий SSD – миттєве завантаження без очікування", boldWords: ["Швидкий SSD"] },
            { text: "Ексклюзиви PS5 – тільки для PlayStation", boldWords: ["Ексклюзиви PS5"] },
            { text: "Імерсивний геймплей – тактильний зворотний зв’язок і 3D-аудіо", boldWords: ["Імерсивний геймплей"] },
            { text: "Підтримка дисків – грайте без обмежень на Blu-Ray", boldWords: ["Підтримка дисків"] },
            { text: "Легке підключення – HDMI, кабель живлення в комплекті", boldWords: ["Легке підключення"] }
        ],
        details: {
            weight: "4.5 кг",
            dimensions: "39х10.4х26 см",
            resolution: "4K, 120 FPS, HDR",
            storage: "1 ТБ SSD",
            library: "PlayStation Plus Extra / Premium",
        },
        pricing: {
            basePrices: [650, 980, 1170],
            dailyRate: 320
        }
    },
    {
        id: 3,
        name: "PS4 Pro",
        KIT: 'PS4_PRO_KIT' ,
        image: [PS4_1, PS4_2, PS4_3, PS4_4],
        features: [
            { text: "Перевірена класика – величезна бібліотека ігор", boldWords: ["Перевірена класика"] },
            { text: "Чітка графіка – 4К, HDR для максимальної деталізації", boldWords: ["Чітка графіка"] },
            { text: "Ексклюзиви PlayStation – тільки на PS4 і PS5", boldWords: ["Ексклюзиви PlayStation"] },
            { text: "Плавний геймплей – потужний процесор для комфортної гри", boldWords: ["Плавний геймплей"] },
            { text: "Розширені можливості – VR, стрімінг, мультимедіа", boldWords: ["Розширені можливості"] },
            { text: "Зручне підключення – HDMI, кабель живлення в комплекті", boldWords: ["Зручне підключення"] }
        ],
        details: {
            weight: "3.3 кг",
            dimensions: "32.7х29.5х5.5 см",
            resolution: "4K, HDR",
            storage: "1 ТБ HDD",
            library: "PlayStation Plus Collection",
        },
        pricing: {
            basePrices: [390, 580, 690],
            dailyRate: 190
        }
    },
    {
        id: 1,
        name: "Xbox Series S",
        KIT: 'XBOX_SERIES_S_KIT' ,
        image: [XboxSeriesS_1, XboxSeriesS_2, XboxSeriesS_3, XboxSeriesS_4],
        features: [
            { text: "Доступ до нових ігор – підтримка всіх актуальних проектів", boldWords: ["Доступ до нових ігор"] },
            { text: "Чудова графіка – 2К, 120 FPS, HDR", boldWords: ["Чудова графіка"] },
            { text: "Швидкий SSD – миттєве завантаження без лагів", boldWords: ["Швидкий SSD"] },
            { text: "Game Pass Ultimate – сотні ігор у підписці", boldWords: ["Game Pass Ultimate"] },
            { text: "Компактний і легкий – ідеальний для будь-якого простору", boldWords: ["Компактний і легкий"] },
            { text: "Легке підключення – HDMI, кабель живлення в комплекті", boldWords: ["Легке підключення"] }
        ],
        details: {
            weight: "1.9 кг",
            dimensions: "27x15x7 см",
            resolution: "2K, 120 FPS, HDR",
            storage: "512 ГБ SSD",
            library: "Xbox Game Pass Ultimate",
        },
        pricing: {
            basePrices: [510, 760, 900],
            dailyRate: 250
        }
    },
    {
        id: 4,
        name: "Xbox Series X",
        KIT: 'XBOX_SERIES_X_KIT' ,
        image: [XboxSeriesX_1, XboxSeriesX_2, XboxSeriesX_3, XboxSeriesX_4],
        features: [
            { text: "Максимальна продуктивність – 4К, 120 FPS, HDR", boldWords: ["Максимальна продуктивність"] },
            { text: "Швидке завантаження – SSD 1 ТБ, Xbox Velocity Architecture", boldWords: ["Швидке завантаження"] },
            { text: "Повна бібліотека ігор – підтримка нових і старих проектів", boldWords: ["Повна бібліотека ігор"] },
            { text: "Game Pass Ultimate – доступ до сотень топових ігор", boldWords: ["Game Pass Ultimate"] },
            { text: "Зручне підключення – HDMI, кабель живлення в комплекті", boldWords: ["Зручне підключення"] },
            { text: "Стильний дизайн – компактний корпус", boldWords: ["Стильний дизайн"] }
        ],
        details: {
            weight: "4.45 кг",
            dimensions: "30.1х15.1х15.1 см",
            resolution: "4K, 120 FPS, HDR",
            storage: "1 ТБ SSD",
            library: "Xbox Game Pass Ultimate",
        },
        pricing: {
            basePrices: [600, 900, 1080],
            dailyRate: 300
        }
    },
    {
        id: 5,
        name: "PlayStation 5 Slim",
        KIT: 'PS5_SLIM_BLU_RAY_KIT' ,
        image: [PS5SlimBluRay_1, PS5SlimBluRay_2, PS5SlimBluRay_3, PS5SlimBluRay_4],
        features: [
            { text: "Підтримує всі нові та старі ігри", boldWords: ["Підтримує"] },
            { text: "Ідеальна графіка (4K – 120 FPS, HDR)", boldWords: ["Ідеальна графіка"] },
            { text: "Ексклюзиви для PS4Pro", boldWords: ["Ексклюзиви"] },
            { text: "Повне занурення (Підтримка тактильних функцій контролера)", boldWords: ["Повне занурення"] },
            { text: "Два геймпади: Можна грати удвох", boldWords: ["Два геймпади"] },
            { text: "Легке підключення (HDMI, Кабель живлення в комплекті)", boldWords: ["Легке підключення"] },
            { text: "Стильно і зручно розташувати (Розміри 39x11x25)", boldWords: ["Стильно і зручно"] },
        ],
        details: {
            weight: "3.2 к",
            dimensions: "35.8х9.6х21.6 см",
            resolution: "4K, 120 FPS, HDR",
            storage: "1 ТБ SSD",
            library: "PlayStation Plus Extra / Premium",
        },
        pricing: {
            basePrices: [650, 980, 1170],
            dailyRate: 320
        }
    },
    {
        id: 6,
        name: "Meta Quest 3 512GB",
        KIT: 'META_QUEST_3_KIT' ,
        image: [MQ3_1, MQ3_2, MQ3_3, MQ3_4],
        features: [
            { text: "Повна автономність – працює без ПК і консолі", boldWords: ["Повна автономність"] },
            { text: "Максимальна чіткість – 4К+ роздільна здатність, 120 Гц", boldWords: ["Максимальна чіткість"] },
            { text: "Потужний процесор – Snapdragon XR2 Gen 2 для плавного геймплею", boldWords: ["Потужний процесор"] },
            { text: "Великий обсяг пам’яті – 512 ГБ для сотень ігор та додатків", boldWords: ["Великий обсяг пам’яті"] },
            { text: "Занурення в реальність – кольоровий Passthrough та 3D-аудіо", boldWords: ["Занурення в реальність"] },
            { text: "Зручний дизайн – легкий, комфортний та регульований", boldWords: ["Зручний дизайн"] }
        ],
        details: {
            weight: "0.515 кг",
            dimensions: "19.2х10.1х14.2 см",
            resolution: "4K+, 120 Гц",
            storage: "512 ГБ",
            library: "Meta Quest Store + підтримка ПК-ігор (Air Link, Virtual Desktop)",
        },
        pricing: {
            basePrices: [680, 1040, 1260],
            dailyRate: 350
        }
    },
];

export default consoleDetails;
